import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HighlightVariablesPipe } from '../../../../pipes/highlight-variables.pipe';
import { QuestionTreeNode } from '../../../interaction-editor/interaction-editor.component';

@Component({
  selector: 'app-flow-question-node',
  imports: [HighlightVariablesPipe],
  templateUrl: './flow-question-node.component.html',
  styleUrl: './flow-question-node.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowQuestionNodeComponent {
  readonly data = input.required<QuestionTreeNode>();
}
